import { computed } from 'mobx'
import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase'
import { type Contact } from 'entities/Contacts/model/Contact'

export class RowContact extends RowBase<Contact> {
  constructor(origin: Contact) {
    super(origin)

    makeObservableRowBase(this, {
      isNew: computed,
      isArchived: computed,
    })
  }

  get isNew() {
    return this.origin.isNew
  }

  get isArchived() {
    return this.origin.isArchived
  }
}
